import {db} from '@/firebase'
import EventEmitter from 'events'
import { store } from '@/store'

// Extend EventEmitter so user of AdminRepository can react to our own defined events. (ex: doctorRepository.on('added'))
class PatientRepository extends EventEmitter {

    find (userId, onSuccess, onError) {
        db.collection('patients')
            .doc(userId)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    onSuccess(doc.data())
                } else {
                    onError()
                }
            })
    }

    all (onSuccess, onError) {
        db.collection('patients')
            .get()
            .then((querySnapshot) => {
                let patients = querySnapshot.docs.map((doc) => {
                    return doc.data()
                })

                onSuccess(patients)
            })
            .catch((error) => {
                onError(error)
            })
    }

    create (user, onSuccess, onError) {
        let patient = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          language: store.state.frontLanguage ? store.state.frontLanguage : 'en',
          registrationDate: new Date(),
          notificationTokens: []
        }

        db.collection('patients')
          .doc(user.uid)
          .set(patient)
          .then(() => {
            onSuccess(patient)
          })
          .catch(onError)
    }

    createOrUpdate (firebaseUser, onSuccess, onError) {
      this.find(firebaseUser.uid, () => {
          // Patient exists
          let patient = {
            id: firebaseUser.uid,
            name: firebaseUser.displayName,
            // email: firebaseUser.email
          }
          this.update(patient, () => {
            this.find(firebaseUser.uid, onSuccess, onError)
          }, onError)
      }, () => {
          // Patient does not exist
          this.create(firebaseUser, onSuccess, onError)
      })
    }

    update (patient, onSuccess, onError) {
        db.collection('patients')
          .doc(patient.id)
          .update(patient)
          .then(onSuccess)
          .catch(onError)
    }

}

export default new PatientRepository()



// WEBPACK FOOTER //
// ./src/data/PatientRepository.js